import {
	Component,
	OnInit,
	AfterViewInit,
	ChangeDetectorRef,
	ElementRef,
	ViewChild,
	ContentChildren,
	QueryList,
	Output,
	EventEmitter
} from '@angular/core';
import { LocaleService } from '@app/system/services/locale.service';
import { FlipBlockItemComponent } from './flip-block-item/flip-block-item.component';

@Component({
	selector: 'app-flip-block',
	templateUrl: './flip-block.component.html',
	styleUrls: ['./flip-block.component.scss']
})
export class FlipBlockComponent implements OnInit, AfterViewInit {

	@ContentChildren(FlipBlockItemComponent) flipItems: QueryList<FlipBlockItemComponent>;
	@Output() currentFlipBlock = new EventEmitter();

	index = 0;
	childLength = 0;
	currentIndex = 1;

	constructor(
		public locale: LocaleService,
		private cdref: ChangeDetectorRef
	) { }

	ngOnInit(): void { }

	ngAfterViewInit() {
		// console.log(this.flipItems);
		// const el: HTMLElement = this.flipItems.nativeElement;
		// this.childLength = el.children.length;
		// for (let i = 0; i < this.childLength; i++) {
		// 	if (i > 0) {
		// 		(el.children[i] as HTMLElement).setAttribute(
		// 			'displayData',
		// 			(el.children[i] as HTMLElement).style.display
		// 		);
		// 		(el.children[i] as HTMLElement).style.display = 'none';
		// 		this.cdref.detectChanges();
		// 	}
		// }
		this.childLength = this.flipItems.length;
		this.flipItems.forEach((resp, index) => {
			if (navigator.onLine) {
				if (index === 0) {
					this.currentFlipBlock.emit(resp.data);
					resp.trigger = 'active';
					// this.cdref.detectChanges();
				} else {
					resp.trigger = 'closed';
					// this.cdref.detectChanges();
				}
			}
		});
		this.cdref.detectChanges();
	}

	slidenNext() {
		// const el: HTMLElement = this.flipItems.nativeElement;
		// if (this.currentIndex === this.childLength) {
		// 	(el.children[this.index] as HTMLElement).style.display = 'none';
		// 	this.index = 0;
		// 	this.currentIndex = 1;
		// 	const value = el.children[this.index] as HTMLElement;
		// 	if (value.getAttribute('displayData')) {
		// 		value.style.display = value.getAttribute('displayData');
		// 	} else {
		// 		value.style.display = 'block';
		// 	}
		// 	return;
		// }
		// if (el.children[this.index] && el.children[this.index + 1] && this.currentIndex <= this.childLength) {
		// 	(el.children[this.index] as HTMLElement).style.display = 'none';
		// 	this.currentIndex += 1;
		// 	this.index += 1;
		// 	if (el.children[this.index]) {
		// 		const value = el.children[this.index] as HTMLElement;
		// 		if (value.getAttribute('displayData')) {
		// 			value.style.display = value.getAttribute('displayData');
		// 		} else {
		// 			value.style.display = 'block';
		// 		}
		// 	}
		// }
		if (navigator.onLine) {
			if (this.currentIndex === this.childLength) {
				this.currentIndex = 1;
			} else if (this.currentIndex <= this.childLength) {
				this.currentIndex += 1;
			}
			this.flipItems.forEach((resp, index) => {
				if (index + 1 === this.currentIndex) {
					this.currentFlipBlock.emit(resp.data);
					resp.trigger = 'active';
				} else {
					resp.trigger = 'closed';
				}
			});
		}
	}

	slidePrev() {
		// const el: HTMLElement = this.flipItems.nativeElement;
		// if (el.children[this.index] && el.children[this.index - 1] && this.currentIndex <= this.childLength) {
		// 	(el.children[this.index] as HTMLElement).style.display = 'none';
		// 	this.currentIndex -= 1;
		// 	this.index -= 1;
		// 	if (el.children[this.index]) {
		// 		const value = el.children[this.index] as HTMLElement;
		// 		if (value.getAttribute('displayData')) {
		// 			value.style.display = value.getAttribute('displayData');
		// 		} else {
		// 			value.style.display = 'block';
		// 		}
		// 	}
		// }
	}
}
